<template>
<GeneralContainer>
    <div class="contact">

        <h1>Contact Us</h1>
        <ContactForm></ContactForm>

    </div>
</GeneralContainer>
</template>

<script>
import ContactForm from "@/components/contact/ContactForm";
import GeneralContainer from "@/components/base/GeneralContainer";

export default {
    name: "ContactPage",

    components: {
        ContactForm,
		GeneralContainer
    },

};
</script>
